export default __webpack_public_path__ + "static/media/verzeo.6849ad1c.jpg";